{
    "home": {
        "title": "Home",
        "welcome": "Welcome",
        "welcome_user": "Welcome, %{user}"
    }
}